// Open modal dialogs, newest last. A modal <dialog> makes everything outside it inert (no clicks,
// hidden from screen readers), so page-level overlays such as toasts render inside the top one.

export interface ModalLayer {
  dialog: HTMLDialogElement
  /** Empty element inside the dialog that overlays can portal into. */
  slot: HTMLElement
}

const stack: ModalLayer[] = []
const listeners = new Set<() => void>()
let top: ModalLayer | null = null

function emit() {
  top = stack[stack.length - 1] ?? null
  for (const fn of listeners) fn()
}

export function pushModal(layer: ModalLayer): void {
  stack.push(layer)
  emit()
}

export function popModal(dialog: HTMLDialogElement): void {
  const i = stack.findLastIndex((l) => l.dialog === dialog)
  if (i === -1) return
  stack.splice(i, 1)
  emit()
}

export function topModal(): ModalLayer | null {
  return top
}

export function subscribeModals(fn: () => void): () => void {
  listeners.add(fn)
  return () => {
    listeners.delete(fn)
  }
}
